import type {Step, Tour} from "nextstepjs";
import Icon, {ICON_TYPE} from "@/components/library/Icon";

export const GAILGPT_WELCOME_TOUR_NAME = "gailGptWelcomeTour";

export interface GailGptWelcomeTourVisibility {
   showAssistantSelector: boolean;
   showGailsNav: boolean;
   showHistoryNav: boolean;
}

function tourIcon(name: Parameters<typeof Icon>[0]["icon"]) {
   return <Icon icon={name} type={ICON_TYPE.DUOTONE} />;
}

function buildStep(step: Step): Step {
   return {
      showControls: true,
      showSkip: true,
      pointerPadding: 8,
      pointerRadius: 12,
      ...step,
   };
}

export function buildGailGptWelcomeTourSteps(
   t: (key: string) => string,
   visibility: GailGptWelcomeTourVisibility
): Tour[] {
   const steps: Step[] = [
      buildStep({
         icon: tourIcon("hand-wave"),
         title: t("onboarding.welcomeTitle"),
         content: t("onboarding.welcome"),
      }),
   ];

   if (visibility.showAssistantSelector) {
      steps.push(
         buildStep({
            icon: tourIcon("user-headset"),
            title: t("onboarding.step1Title"),
            content: t("onboarding.step1"),
            selector: '[data-tour="assistant-selector"]',
            side: "bottom",
         })
      );
   }

   steps.push(
      buildStep({
         icon: tourIcon("wand-magic-sparkles"),
         title: t("onboarding.step2Title"),
         content: t("onboarding.step2"),
         selector: '[data-tour="suggestions-container"]',
         side: "top",
      })
   );

   if (visibility.showGailsNav) {
      steps.push(
         buildStep({
            icon: tourIcon("user-headset"),
            title: t("onboarding.step3Title"),
            content: t("onboarding.step3"),
            selector: '[data-tour="gails-nav"]',
            side: "right",
            pointerPadding: 4,
            pointerRadius: 8,
         })
      );
   } else if (visibility.showHistoryNav) {
      steps.push(
         buildStep({
            icon: tourIcon("clock"),
            title: t("onboarding.historyTitle"),
            content: t("onboarding.history"),
            selector: '[data-tour="history-nav"]',
            side: "right",
            pointerPadding: 4,
            pointerRadius: 8,
         })
      );
   }

   steps.push(
      buildStep({
         icon: tourIcon("comment"),
         title: t("onboarding.step4Title"),
         content: t("onboarding.step4"),
         selector: '[data-tour="chat-input"]',
         side: "top",
         showSkip: false,
      })
   );

   return [{tour: GAILGPT_WELCOME_TOUR_NAME, steps}];
}
